module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"base":"_0_2_5_button__base___3QXLU","font":"_0_2_5_button__font___nhfv1","font-size-xs":"_0_2_5_button__font-size-xs___2cNTS","font-size-s":"_0_2_5_button__font-size-s___u9KZl","font-size-m":"_0_2_5_button__font-size-m___1G6E4","font-size-l":"_0_2_5_button__font-size-l___8iJ-n","size-xs":"_0_2_5_button__size-xs___2zUS9","size-s":"_0_2_5_button__size-s___Y5fQv","size-m":"_0_2_5_button__size-m___UCr3p","size-l":"_0_2_5_button__size-l___3BxYo","color-light-mode-primaryCTA":"_0_2_5_button__color-light-mode-primaryCTA___33Kqx","color-light-mode-primary":"_0_2_5_button__color-light-mode-primary___1rpIM","color-light-mode-secondary":"_0_2_5_button__color-light-mode-secondary___3Vp6T","color-dark-mode-primaryCTA":"_0_2_5_button__color-dark-mode-primaryCTA___1kECk","color-dark-mode-primary":"_0_2_5_button__color-dark-mode-primary___3sMsI","color-dark-mode-secondary":"_0_2_5_button__color-dark-mode-secondary___1rAU2","link-button":"_0_2_5_button__link-button___2fvR-","link-button-light-mode":"_0_2_5_button__link-button-light-mode___3BsnK","link-button-dark-mode":"_0_2_5_button__link-button-dark-mode___Gz_jj","close-button":"_0_2_5_button__close-button___3YCRz","close-button-light-mode":"_0_2_5_button__close-button-light-mode___hNmgU","close-button-dark-mode":"_0_2_5_button__close-button-dark-mode___6EIFP"};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("@runity/ui-icons");

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Button", function() { return /* reexport */ Button; });

// EXTERNAL MODULE: external "tslib"
var external_tslib_ = __webpack_require__(3);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// CONCATENATED MODULE: ./src/types.ts
var EButtonType;
(function (EButtonType) {
    EButtonType["button"] = "button";
    EButtonType["link"] = "link";
    EButtonType["close"] = "close";
})(EButtonType || (EButtonType = {}));
var EButtonColor;
(function (EButtonColor) {
    EButtonColor["primaryCTA"] = "primaryCTA";
    EButtonColor["primary"] = "primary";
    EButtonColor["secondary"] = "secondary";
})(EButtonColor || (EButtonColor = {}));
var EButtonSize;
(function (EButtonSize) {
    EButtonSize["xs"] = "xs";
    EButtonSize["s"] = "s";
    EButtonSize["m"] = "m";
    EButtonSize["l"] = "l";
})(EButtonSize || (EButtonSize = {}));
var EButtonTheme;
(function (EButtonTheme) {
    EButtonTheme["light"] = "light";
    EButtonTheme["dark"] = "dark";
})(EButtonTheme || (EButtonTheme = {}));

// EXTERNAL MODULE: external "@runity/ui-icons"
var ui_icons_ = __webpack_require__(4);

// EXTERNAL MODULE: ./src/styles/button.scss
var styles_button = __webpack_require__(0);
var button_default = /*#__PURE__*/__webpack_require__.n(styles_button);

// CONCATENATED MODULE: ./src/Button.tsx






var Button = function (_a) {
    var _b = _a.buttonType, buttonType = _b === void 0 ? EButtonType.button : _b, _c = _a.color, color = _c === void 0 ? EButtonColor.primaryCTA : _c, _d = _a.size, size = _d === void 0 ? EButtonSize.m : _d, _e = _a.theme, theme = _e === void 0 ? EButtonTheme.light : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, children = _a.children, className = _a.className, onCloseClick = _a.onCloseClick, rest = Object(external_tslib_["__rest"])(_a, ["buttonType", "color", "size", "theme", "disabled", "children", "className", "onCloseClick"]);
    var classNames = external_classnames_default()(button_default.a.base, button_default.a.font, button_default.a["font-size-" + size], button_default.a["size-" + size], button_default.a["color-" + theme + "-mode-" + color], className);
    var linkButtonClassNames = external_classnames_default()(button_default.a['link-button'], button_default.a.font, button_default.a["font-size-" + size], button_default.a["size-" + size], button_default.a["link-button-" + theme + "-mode"], className);
    if (buttonType === EButtonType.close) {
        return (external_react_default.a.createElement("button", { type: "button", disabled: disabled, className: external_classnames_default()(button_default.a['close-button'], button_default.a["close-button-" + theme + "-mode"], button_default.a["size-" + size], className), onClick: onCloseClick },
            external_react_default.a.createElement(ui_icons_["Close"], null)));
    }
    return (external_react_default.a.createElement("button", Object(external_tslib_["__assign"])({ className: buttonType === EButtonType.link ? linkButtonClassNames : classNames, disabled: disabled, type: "button" }, rest), children));
};

// CONCATENATED MODULE: ./index.ts



/***/ })
/******/ ]);